import { render, staticRenderFns } from "./AnswerGrade.vue?vue&type=template&id=a235c2c4"
import script from "./AnswerGrade.vue?vue&type=script&lang=js"
export * from "./AnswerGrade.vue?vue&type=script&lang=js"
import style0 from "./AnswerGrade.vue?vue&type=style&index=0&id=a235c2c4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports